<template>
    <div class="modal fade" id="AdminUserModal" tabindex="-1" role="dialog" aria-labelledby="AdminUserModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="AdminUserModalLabel">{{ isEdit ? __('admins.add') : __('admins.update') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="app-card-notification"  v-if="isEdit">
                        <div class="notification-type my-2">
                            <span class="badge bg-info">{{ __('admins.new-admin-notification') }}d</span>
                        </div>
                    </div>
                    <form>
                        <div class="form-group">
                            <label for="name" class="col-form-label">{{ __('admins.name') }}:</label>
                            <input type="text" class="form-control" id="name" v-model="admin.name">
                            <span v-if="errors.name" class="invalid-feedback d-block">{{ errors.name[0] }}</span>
                        </div>
                        <div class="form-group">
                            <label for="email" class="col-form-label">{{ __('admins.email') }}:</label>
                            <input type="email" class="form-control" id="email" v-model="admin.email">
                            <span v-if="errors.email" class="invalid-feedback d-block">{{ errors.email[0] }}</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn app-btn-secondary" data-bs-dismiss="modal">{{ __('actions.close') }}</button>
                    <button type="button" class="btn app-btn-primary" @click="isEdit ? addUser() : updateUser()">{{ __('actions.submit') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditUserModal",

    data: function () {
        return {
            admin: {
                email: null,
                name: null,
                role: null
            },
            errors: [],
        }
    },

    mounted: function () {
        $('#AdminUserModal').on('hide.bs.modal', () => {
            this.admin = {
                email: null,
                name: null,
                role: null
            }
            this.errors = {}
        })
    },

    computed: {
        isEdit: function () {
            return !!this.admin.role;
        },
    },

    methods: {
        setUser: function (admin) {
            this.admin = admin
        },

        setRole: function (role) {
            this.admin.role = role
        },

        addUser: function () {
            axios.post(`/admins`, this.admin).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                $('#AdminUserModal').modal('hide')
                this.emit('updated')
            }).catch(error => {
	            Toast.fire({icon: 'error', title: error.response.data.message})
                this.errors = error.response.data.errors
            })
        },

        updateUser: function () {
            axios.put(`/admins/${this.admin.id}`, this.admin).then(response => {
                Toast.fire({icon: 'success', title: response.data.message})
                $('#AdminUserModal').modal('hide')
                this.emit('updated')
            }).catch(error => {
	            Toast.fire({icon: 'error', title: error.response.data.message})
                this.errors = error.response.data.errors
            })
        }
    }
}
</script>

<style scoped>

</style>
